import { useMutation, useQuery } from "react-query";
import { AxiosError } from "axios";
import { BaseResponse } from "../_types";
import { axiosInstance } from "../../config/axios";
import { QueryKeys } from "../queryKeys";

async function getSectorMapping(id: number): Promise<BaseResponse<any>> {
    try {
        const response = await axiosInstance.get("/Merchant/GetInstallmentMappingSector?id=" + id);
        return response.data;
    } catch (ex) {
        throw ((ex as AxiosError).response?.data as any).error;
    }
}

export function useGetSectorMapping(id: number) {
    return useMutation<any | undefined, Error, number>(
        (id) => getSectorMapping(id)
    );
}